import { departments } from './constants';

export const getStatusColor = (status) => {
  switch (status) {
    case 'approved': return 'Leaves-status-approved';
    case 'pending': return 'Leaves-status-pending';
    case 'rejected': return 'Leaves-status-rejected';
    default: return 'Leaves-status-default';
  }
};
export const getAbsenceTypeColor = (type) => {
  switch (type) {
    case 'LATENESS': return 'primary';
    case 'MULTIPLE_DAYS': return 'error';
    case 'PARTIAL_DAY': return 'secondary';
    case 'FULL_DAY': return 'warning';
    default: return 'default';
    }
  };

export const getPriorityColor = (priority) => {
  switch (priority) {
    case 'High': return 'Leaves-priority-high';
    case 'Medium': return 'Leaves-priority-medium';
    case 'Low': return 'Leaves-priority-low';
    case 'Urgent': return 'Leaves-priority-urgent';
    default: return 'Leaves-priority-default';
  }
};

// helpers.js (or wherever calculateDuration is defined)

export const calculateDuration = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;

  const start = new Date(startDate);
  const end = new Date(endDate);

  // Normalize to start of day
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  let businessDays = 0;
  const currentDate = new Date(start);

  while (currentDate <= end) {
    const dayOfWeek = currentDate.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
    if (dayOfWeek !== 0) { // Skip Sunday
      businessDays++;
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return businessDays;
};

// export const formatDate = (dateString) => {
//   const date = new Date(dateString);
//   return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
// };

// In helpers.js
export const formatDate = (date) => {
  if (!date) return 'N/A';
  const parsedDate = new Date(date);
  return isNaN(parsedDate.getTime()) ? 'N/A' : parsedDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  });
};

export const getDepartmentStats = (leavesData, monthFilter = null) => {
  const stats = {};
  departments.forEach(dept => {
    const deptLeaves = leavesData.filter(leave => {
      const leaveMonth = new Date(leave.startDate).getMonth() + 1;
      return leave.department === dept && (!monthFilter || leaveMonth === monthFilter);
    });
    stats[dept] = {
      total: deptLeaves.length,
      pending: deptLeaves.filter(l => l.status === 'Pending').length,
      approved: deptLeaves.filter(l => l.status === 'Approved').length,
      rejected: deptLeaves.filter(l => l.status === 'Rejected').length
    };
  });
  return stats;
};

export const getUpcomingLeaves = (leavesData) => {
  const today = new Date();
  return leavesData
    .filter(leave => new Date(leave.startDate) > today && leave.status === 'Approved')
    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
    .slice(0, 5);
};

export const getCriticalRequests = (leavesData) => {
  return leavesData.filter(leave => 
    leave.status === 'Pending' && 
    (leave.priority === 'High' || leave.priority === 'Urgent' || 
     !leave.coverageArranged || !leave.handoverCompleted)
  );
};

export const calculateBusinessDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    // Reset time parts to avoid timezone issues
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    
    let businessDays = 0;
    const current = new Date(start);
    
    // Iterate through each day
    while (current <= end) {
        const dayOfWeek = current.getDay();
        // Sunday = 0, Saturday = 6
        //if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        if (dayOfWeek !== 0) {
            businessDays++;
        }
        current.setDate(current.getDate() + 1);
    }
    
    return businessDays;
};

export const AbsenceTypeLabels = {
    LATENESS: 'Lateness',
    PARTIAL_DAY: 'Partial Day',
    FULL_DAY: 'Full Day',
    MULTIPLE_DAYS: 'Multiple Days',
    SICKNESS: 'Sickness',
    EARLY_DEPARTURE: 'Early Departure', 
    EMERGENCY: 'Emergency',
    PERSONAL: 'Personal',
    APPOINTMENT: 'Appointment',
  };
